export default __webpack_public_path__ + "static/media/logo_AHS.99c45568.svg";